import React from 'react'

function NotAllowed() {
  return (
    <div>NotAllowed</div>
  )
}

export default NotAllowed